import { isWeekday, getProductFrom, upgradeSelected } from './utils'
// eslint-disable-next-line import/no-duplicates
import BookingLib from './booking'
// eslint-disable-next-line import/no-duplicates
import { isEligibleForVolumeDiscount, volumeDiscount, calculateHoursCount, couponValue } from './booking'

const buildStripeItems = (booking, skus, overrideHours, email) => {
  const items = []
  const hoursCount = calculateHoursCount(booking.whenStartTime, booking.whenEndTime)

  // Claculate days which are considered special weekeends from override hours array
  const specialWeekends = overrideHours.filter(d => d.isWeekend)

  const addPersonInfoToItems = person => {
    const passType = person.passType || person.membership.type
    const ageCategory = person.ageCategory || person.membership && person.membership.ageCategory
    const product = getProductFrom(passType)

    // Aggregate passes
    if (!person.membership || upgradeSelected(person)) {
      const passItem = items.find(i => i.parent === product.skuId)
      if (passItem) {
        passItem.quantity += 1 
      } else {
        items.push({ parent: product.skuId, quantity: 1 })
      }
    }

    // Aggregate hours
    const hoursSkuToUse = isWeekday(new Date(booking.whenStartTime), specialWeekends) ? 'hourRateWeekdaysSkuId' : 'hourRateWeekendsSkuId'
    const hoursItem = items.find(i => i.parent === product[hoursSkuToUse])
    if (hoursItem) {
      hoursItem.quantity += hoursCount
    } else {
      items.push({ parent: product[hoursSkuToUse], quantity: hoursCount })
    }

    // Volume discount
    if (isEligibleForVolumeDiscount(passType, hoursCount)) {
      items.push({
        parent: product[hoursSkuToUse],
        type: 'discount',
        amount: volumeDiscount(ageCategory) * 100,
        currency: 'dkk',
        description: 'Volume discount'
      })
    }           

    // INSURANCE
    // if (!person.membership || Utils.useDailyInsurance(person.membership.type)) {
    //   const mandatoryInsuranceSkuId = Utils.useDailyInsurance(passType)
    //     ? Utils.getProductFrom('insurance').mandatoryDailySkuId
    //     : Utils.getProductFrom('insurance').mandatoryYearlySkuId

    //   const mandatoryInsuranceItem = items.find(i => i.parent === mandatoryInsuranceSkuId)
    //   if (mandatoryInsuranceItem) {
    //     mandatoryInsuranceItem.quantity += 1
    //   } else {
    //     items.push({ parent: mandatoryInsuranceSkuId, quantity: 1 })
    //   }  
    // }

    if (person.insuranceCancellation) {
      const {cancellationSkuId} = getProductFrom('insurance')
      const cancellationItem = items.find(i => i.parent === cancellationSkuId)
      if (cancellationItem) {
        cancellationItem.quantity += 1
      } else {
        items.push({ parent: cancellationSkuId, quantity: 1 })
      }
    }

    if (person.rental && person.rental.insurance) {
      const { rentalSkuId } = getProductFrom('insurance')
      const rentalInsuranceItem = items.find(i => i.parent === rentalSkuId)
      if (rentalInsuranceItem) {
        rentalInsuranceItem.quantity += 1
      } else {
        items.push({ parent: rentalSkuId, quantity: 1 })
      }          
    }        

    // INSTRUCTION
    if (person.instruction && person.instruction.skuId) {
      const instructionItem = items.find(i => i.parent === person.instruction.skuId)
      if (instructionItem) {
        instructionItem.quantity += 1
      } else {
        items.push({ parent: person.instruction.skuId, quantity: 1})
      }          
    }

    // RENTAL
    if (person.rental && person.rental.equipment) {
      Object.keys(person.rental.equipment).forEach(key => {
        
        if (person.rental.equipment[key]) {
          const rentalSkuId = person.rental.equipment[key]
          const rentalItem = items.find(i => i.parent === rentalSkuId)
          if (rentalItem) {
            rentalItem.quantity += 1
          } else {
            items.push({ parent: rentalSkuId, quantity: 1 })
          }
        }
      });
    }
   
    // Replacement card
    if (person.replacementCard) {
      const { replacementCardSkuId } = getProductFrom('misc')
      const replacementCardItem = items.find(i => i.parent === replacementCardSkuId)
      if (replacementCardItem) {
        replacementCardItem.quantity += 1
      } else {
        items.push({ parent: replacementCardSkuId, quantity: 1 })
      }
    }

    // Voucher discount
    if (person.appliedVoucher && !person.couponInfo) {
      items.push({
        parent: product[hoursSkuToUse],
        quantity: 1,
        type: 'discount',
        amount: BookingLib.voucherValue(person, booking, skus, overrideHours, email) * 100, // person.appliedVoucher.amount * -1
        currency: 'dkk',
        description: `Discount code: ${person.voucher}`
      })
    }

    // Coupon discount
    if (person.couponInfo && !person.appliedVoucher) {
      items.push({
        parent: product[hoursSkuToUse],
        quantity: 1,
        type: 'discount',
        amount: couponValue(person, booking, skus, overrideHours) * 100,
        currency: 'dkk',
        description: `Discount code: ${person.voucher}`
      })
    }
  }      

  // loop through each person and add stripe items
  booking.people.filter(p => !p.invite).forEach(person => { addPersonInfoToItems(person) })
  return items
}

export default buildStripeItems